import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from 'src/app/services/navigation.service';
import { ProductService } from 'src/app/services/product.service';
import { environment } from 'src/environments/environment';
import { AddProductPopupComponent } from './addproductpopup.component';
import { Lightbox } from 'ngx-lightbox';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DealerService } from 'src/app/services/dealer.service';
import { ManufacturerService } from 'src/app/services/manufacturer.service';
import swal from 'sweetalert2';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleType } from 'src/enum/roletype';
import { ManufacturerLockPopupComponent } from '../homanufacturer/manufacturerLockpopup/manufacturerLockpopup.component';
import { ProductimgpopupComponent } from './productupdatepopup/productimgpopup/productimgpopup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RegionService } from 'src/app/services/region.service';
import { UpdatepricepopupComponent } from './updatepricepopup/updatepricepopup.component';
import { SecurityService } from 'src/app/services/security.service';

@Component({
  selector: 'app-viewproduct',
  templateUrl: './viewproduct.component.html',
  styleUrls: ['./viewproduct.component.scss']
})
export class ViewProductComponent implements OnInit {

  products: any[] = [];
  data = [];
  productListDetail: any[] = [];
  verifiedProducts: any[] = [];
  verifiedProductsListDetail: any[] = [];
  approvedProductsList: any[] = [];
  approvedProductsListDetail: any[] = [];
  yettoVerifyproducts: any[] = [];
  yettoVerifyproductsListDetail: any[] = [];
  VerifyproductsListDetail : any = [];
  rejectedproducts: any[] = [];
  rejectedproductsListDetail: any[];
  id: number;
  manufacturerapprove: boolean = false;
  routeParams: any;
  selectedTabIndex: number;
  verifieddataSource = new MatTableDataSource(this.verifiedProductsListDetail);
  verifiedCount: number;
  approvedCount: number;
  notVerifiedCount: number;
  rejectedCount: number;
  loading:boolean;
  productview: boolean = false;
  priceLockStatusType: boolean = false;
  public roletype = RoleType;

  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  @ViewChild('Verified Products', { static: true }) departmentPaginator: MatPaginator;
  @ViewChild('Approval Pending Products', { static: true }) machineryPaginator: MatPaginator;
  @ViewChild('Rejected Products', { static: true }) implmentPaginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  schemeName: string;
  vehiclePhotos: any[] = [];
  vehicleimages: any[] = [];
  manufacturerList: any[];
  manufacturerListDetail: any[];
  verifiedProductsList: any[];
  yettoVerifyproductsList: any[];
  rejectedproductsList: any[];
  financeyear: string;
  isSeekClarification: any;
  roleType: number;
  index: number = -1;
  productname: any;

  form:FormGroup;
  financialyearlist: any[]=[];
  yearsListTabTwo: any[];
  filterfinancialyearlist: any[]=[];
  currentYear: any;
  currentMonth: number;
  curyear: any;
  constructor(
    public navigationService: NavigationService,
    private productService: ProductService,
    public addServiceDialog: MatDialog,
    private alertService: AlertService,
    private _lightbox: Lightbox,
    route: ActivatedRoute,
    private dealerService: DealerService,
    private userSessionService: UserSessionService,
    private manufacturerService: ManufacturerService,
    private modalService:NgbModal,
    private securityService: SecurityService,
    private router: Router,
    private regionService:RegionService,
    private fb:FormBuilder
  ) {
    this.selectedTabIndex = 0;
    this.routeParams = route.snapshot.params;
    let decId = 0;
    if(this.routeParams.id != 0){
       decId = this.securityService.decrypt(this.routeParams.id);
    }
     this.id = decId;
    this.loading = true
    this.roleType = this.userSessionService.roleId();
    if (this.id == 0)
      this.productview = false;
    else
      this.productview = true;

  };

 

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.currentMonth = new Date().getMonth(); 
    // this.getManufacturer();
    this.initialValidators();
    this.getfinancialyear(true);
    // this.get();
    // this.manufacturerapprove = true;
  }

  initialValidators()
  {
    this.form=this.fb.group({
      yearId:[]
    })
  }

  // goToAction(id: number, actionInfo: number, event: number) {
  //   this.navigationService.gotoProductAdd(id, actionInfo, event, 0, 0);
  // }

  getfinancialyear(refresh: boolean) {
    this.regionService.getFinYear(refresh).subscribe(result => {
      if (result) {
        this.financialyearlist = [];
        this.yearsListTabTwo = [];
        this.filterfinancialyearlist = [];
        this.financialyearlist = result;
        // this.filterfinancialyearlist.push({ key: 0, value: "All", startYear: 0, endYear: 0 });
        this.financialyearlist.forEach(element => {
          this.filterfinancialyearlist.push(element);
          this.yearsListTabTwo.push(element);
        });
        this.financialyearlist = this.financialyearlist;
        // this.currentYear = this.financialyearlist.filter(x => x.startYear == this.currentYear);
        var financialYear = "";
        if (this.currentMonth >= 0 && this.currentMonth <= 2) {
          financialYear = "FY " + ((this.currentYear - 1).toString() + '-' + this.currentYear.toString().slice(-2));
        } else {
          financialYear = "FY " + ((this.currentYear).toString() + '-' + (this.currentYear + 1).toString().slice(-2));
        }
        this.curyear = this.financialyearlist.find(i => i.value == financialYear);
        this.form.controls["yearId"].setValue(this.curyear.key);
        localStorage.setItem('year',this.form.value.yearId)
        localStorage.setItem('dateDetails',JSON.stringify(this.currentYear))
        this.getManufacturer();
        // this.form.controls["yearId"].setValue(this.currentYear[0].key);
      }
    });
  }

  changeYear(e)
  {
    this.getManufacturer();
    localStorage.setItem('year',this.form.value.yearId)


  }

  gotoLogin() {
    const title = 'Alert';
    const Yes = 'OK';
    swal.fire(
      {
        title,
        text: 'Your registration yet to be approved by the Agricultural Engineering Department.',
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: Yes,
      }
    )
      .then(res => {
        if (res.value) {
        }
      });
  }


  openproductPopup(id: any, priceLockStatusType: any) {
    const dialogRef = this.addServiceDialog.open(
      ManufacturerLockPopupComponent,
      {
        autoFocus: false,
        disableClose: true,
        width: "45%",
        height: "50%",
        panelClass: "mat-dialog-serviceschedule",
        data: {
          id: id,
          priceLockStatusType: priceLockStatusType,
        },
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
     });
  }


  openPriceproductPopup(data: any) {
    const dialogRef = this.addServiceDialog.open(
      UpdatepricepopupComponent,
      {
        autoFocus: false,
        disableClose: true,
        width: "80%",
        height: "75%",
        panelClass: "mat-dialog-serviceschedule",
        data:data,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if(result)
      {
        this.form.controls["yearId"].setValue(this.currentYear[0].key);
        this.getManufacturer();
        this.selectedTabIndex = 0;

      }
     });
  }

  openPopup() {
    const dialogRef = this.addServiceDialog.open(AddProductPopupComponent, {
      autoFocus: false,
      disableClose: true,
      width: 'auto',
      height: 'auto',
      panelClass: 'mat-dialog-serviceschedule'
    });
  }
 

  activeChange(id: any, item: any) {
    if (item == 1) {
      this.delete(id, item);
    } else {
      this.delete(id, item);
    }
  }

  delete(id: number, status: number) {
    this.productService.delete(id, status,this.form.value.yearId).subscribe(result => {
      if (result) {
        this.get();
      }
    });
  }


  getManufacturer() {
    this.loading=true
    this.manufacturerList = [];
    this.manufacturerListDetail = [];
    this.manufacturerService.getManufacturer(this.id, true).subscribe(res => {
      if (res?.approvedStatusType == 1) {
        this.manufacturerapprove = true;
        this.loading=false
        this.get();
      } else {
        if (this.roleType != RoleType.DBTAdmin) {
          this.gotoLogin();
        }
      }
     
    })
  }


  get() {
    this.products = [];
    this.productListDetail = [];
    this.rejectedproductsListDetail = [];
    this.yettoVerifyproductsListDetail = [];
    this.verifiedProductsListDetail = [];
    this.productService.getProduct(this.id,this.form.value.yearId, true).subscribe(res => {
      if (res) {     
        res?.forEach(element => {
          element.imagePath = environment.imageBaseUrl + 'DBT/ProductImage/' + element.image[0].imagePath;
        });
        this.products = res;
        this.isSeekClarification = res.isSeekClarification;
        this.productListDetail = this.products.slice();

        this.rejectedproductsListDetail = this.productListDetail.filter(i => i.approvedStatusType == 3);
        this.rejectedproductsList = this.rejectedproductsListDetail;
        this.rejectedCount = this.rejectedproductsListDetail.length;

        this.yettoVerifyproductsListDetail = this.productListDetail.filter(i => i.approvedStatusType == 2 && i.priceLockStatusType == 0);
        this.yettoVerifyproductsList = this.yettoVerifyproductsListDetail;
        this.notVerifiedCount = this.yettoVerifyproductsListDetail.length;
        

        this.VerifyproductsListDetail = this.productListDetail.filter(i => i.approvedStatusType == 2 && i.priceLockStatusType != 0);
        this.verifiedCount = this.VerifyproductsListDetail.length;

        this.approvedProductsListDetail = this.productListDetail.filter(i => i.approvedStatusType == 1);
        this.approvedProductsList = this.approvedProductsListDetail;
        this.approvedCount = this.approvedProductsListDetail.length;
        this.schemeName = "SMAM";

      }
    })
  }

  verifieddataFilter(event: any) {
    const value = event.target.value;
    this.verifiedProductsListDetail = this.verifiedProductsList.filter(i => i.machinaryClassificationName.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.machinaryCategoryName.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.productName.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.warrantyYear.toString().trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.capicity.toString().trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.make.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.model.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.productReleaseYear.trim().toLowerCase().includes(value.trim().toLowerCase()));
  }
  approveddataFilter(event: any) {
    const value = event.target.value;
    this.approvedProductsListDetail = this.approvedProductsList.filter(i => i.machinaryClassificationName.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.machinaryCategoryName.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.productName.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.warrantyYear.toString().trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.capicity.toString().trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.make.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.model.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.productReleaseYear.trim().toLowerCase().includes(value.trim().toLowerCase()));
  }
  pendingdataFilter(event: any) {
    const value = event.target.value;
    this.yettoVerifyproductsListDetail = this.yettoVerifyproductsList.filter(i => i.machinaryClassificationName.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.machinaryCategoryName.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.productName.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.warrantyYear.toString().trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.capicity.toString().trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.make.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.model.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.productReleaseYear.trim().toLowerCase().includes(value.trim().toLowerCase()));
  }

  rejecteddataFilter(event: any) {
    const value = event.target.value;
    this.rejectedproductsListDetail = this.rejectedproductsList.filter(i => i.machinaryClassificationName.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.machinaryCategoryName.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.productName.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.warrantyYear.toString().trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.capicity.toString().trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.make.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.model.trim().toLowerCase().includes(value.trim().toLowerCase()) ||
      i.productReleaseYear.trim().toLowerCase().includes(value.trim().toLowerCase()));
  }


  edit(id: number, actionInfo: number) {
    localStorage.setItem("productdetailId", JSON.stringify(this.id));
    const encId = this.securityService.encrypt(id);
    this.navigationService.goTOProductview(encId, actionInfo);
  }
  view(id: number, actionInfo: number) {
    const encId = this.securityService.encrypt(id);
    this.navigationService.goTOProductview(encId, actionInfo);
  }

  download(item: any) {
    const linkSource = environment.imageBaseUrl + 'DBT/Leaflet/' + item.leafletPath;
    const downloadLink = document.createElement('a');
    const fileName = 'Leaflet.pdf';
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  openImage(showImage,item): void {
    this.modalService.open(showImage, { centered: true });
    this.vehiclePhotos = [];
    this.vehicleimages = [];    
    this.vehiclePhotos = item.image;
    this.productname=item.productName

    this.vehiclePhotos.forEach(e => {
      this.vehicleimages.push(
        {
          src: environment.imageBaseUrl + 'DBT/ProductImage/' + e.imagePath,
          thumb: environment.imageBaseUrl + 'DBT/ProductImage/' + e.imagePath,
          
        });
    });
    // this._lightbox.open(this.vehicleimages, 0, { centerVertically: true ,
    // showImageNumberLabel:true, alwaysShowNavOnTouchDevices:true, wrapAround:true,});
  }
// openImage(item):void{ 
//   const dialogRef = this.addServiceDialog.open(
//     ProductimgpopupComponent,
//     {
//       autoFocus: false,
//       disableClose: true,
//       width: "50%",
//       height: "50%",
//       panelClass: "mat-dialog-serviceschedule", 
      
//       data:item    
//     }
//   );  
// } 

  // OpenImageModel(imageSrc,images) {
  //   //alert('OpenImages');
  //   var imageModalPointer;
  //   for (var i = 0; i < images.length; i++) {
  //          if (imageSrc === images[i].img) {
  //            imageModalPointer = i;
  //            break;
  //          }
  //     }
  //   this.openModalWindow = true;
  //   this.images = images;
  //   this.imagePointer  = imageModalPointer;
  // }
}
